<script lang="ts">
import { defineComponent, onMounted, Ref } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { LOCAL_STORAGE_REDIRECT_URI_KEY } from '@/constants'
import { Tenant } from '@/types'
import { client } from '@/services/beef'
import { OmitFirstArg } from '@/store'
import { actions as userActions } from '@/store/modules/User'
import { SubmitPayload } from '../../components/types'
import Activate from '../../components/Activate.vue'
import { useRoute } from '../../router'

const { useActions: useUserStoreActions } = createNamespacedHelpers('User')
const { useState: useLoginDomainStoreState } = createNamespacedHelpers('LoginDomain')

export default defineComponent({
  name: 'RegisterPage',

  components: {
    Activate,
  },

  setup() {

    const currentRoute = useRoute()

    const authenticateAgainstAuth0 = useUserStoreActions(['authenticateAgainstAuth0']).authenticateAgainstAuth0 as OmitFirstArg<typeof userActions.authenticateAgainstAuth0>
    const tenant = useLoginDomainStoreState(['tenant']).tenant as Ref<Tenant>

    const validateRegistrationToken = (token: string) => {

      return client.validateRegistrationToken({
        body: { token },
      })
        .catch((error) => {

          if (error.response) {
            if (error.response.status === 403) {
              throw new Error('TokenInvalid')
            }
          }
          throw error
        })

    }

    const registerUser = (payload: SubmitPayload) => {

      return client.registerUser({ body: payload })
        .catch((error) => {

          if (error.response) {
            if (error.response.status === 403) {
              throw new Error('TokenInvalid')
            }
          }

          throw error

        })

    }

    onMounted(() => {

      // store redirect uri in local storage
      const { redirectUri } = currentRoute.value?.query
      if (redirectUri) {
        localStorage.setItem(LOCAL_STORAGE_REDIRECT_URI_KEY, redirectUri as string)
      }

    })

    const submit = async (payload: SubmitPayload) => {

      const { email } = await registerUser(payload)

      await authenticateAgainstAuth0({
        user: { email, password: payload.password },
        tenant: tenant.value,
      })

    }

    return {
      submit,
      validateRegistrationToken,
    }

  },

})

</script>

<template>
  <Activate
    :submit="submit"
    :validate-token="validateRegistrationToken"
  />
</template>
